enum DATA_TABLE_COMPONENTS {
  ADDRESS = 'ADDRESS',
  BACKGROUND_CELL = 'BACKGROUND_CELL',
  CASE_STATUS_LOCATION = 'CASE_STATUS_LOCATION',
  COMPOSED_LINK = 'COMPOSED_LINK',
  CONJOINED = 'CONJOINED',
  DROPDOWN = 'DROPDOWN',
  DROPDOWN_MODAL = 'DROPDOWN_MODAL',
  DUPLICATED_PERSON = 'DUPLICATED_PERSON',
  FORMAT = 'FORMAT',
  HIDDEN_CELL = 'HIDDEN_CELL',
  HOLD_STATUS_V2 = 'HOLD_STATUS_V2',
  IMAGE = 'IMAGE',
  IMAGE_LINK = 'IMAGE_LINK',
  INLINE_GROUP = 'INLINE_GROUP',
  INPUT_NUMBER = 'INPUT_NUMBER',
  KENNEL_MANAGER_CELL = 'KENNEL_MANAGER_CELL',
  LINK = 'LINK',
  LIST_COUNT = 'LIST_COUNT',
  LOGIN_AS = 'LOGIN_AS',
  MONEY = 'MONEY',
  MULTISELECT = 'MULTISELECT',
  OPEN_MODAL_CELL = 'OPEN_MODAL_CELL',
  PASSWORD_EXPIRY = 'PASSWORD_EXPIRY',
  RECEIPT = 'RECEIPT',
  STAFF_EMAIL_VERIFICATION = 'STAFF_EMAIL_VERIFICATION',
  STAFF_PHONE_VERIFICATION = 'STAFF_PHONE_VERIFICATION',
  SHELTER_STATUS = 'SHELTER_STATUS',
  TAG = 'TAG',
  TEXT_AREA = 'TEXT_AREA',
  VOUCHERS = 'VOUCHERS',
}

enum FORMAT_COMPONENTS {
  ADOPTION_FEE = 'adoption_fee',
  ARRAY_LENGTH = 'arrayLength',
  BIRTHDAY = 'birthday',
  COMPOSED_STRING_LINK = 'composedStringLink',
  CONCATENATE = 'concatenate',
  DATE_FROM_OID = 'dateFromOId',
  DATE_TO_ISO_STRING = 'dateToIsoString',
  DATE_STRING_WITH_TIME = 'dateStringWithTime',
  DAYS_TO_FIXED = 'daysToFixed',
  DATE_TIME_TO_DATE = 'dateTimeToDate',
  DECIMAL_TO_MONEY = 'decimalToMoney',
  EXTRA_INFO = 'extraInfo',
  NUMBER_TO_BIRTHDAY = 'numberBirthday',
  NUMBER_TO_DATE = 'dateNumber',
  MONEY = 'money',
  OBJECT_MODEL = 'objectModel',
  PHONE = 'phone',
  WEIGHT = 'weight',
  NEW_PLATFORM = 'new_platform',
  PERCENTAGE = 'percentage',
  SECONDS_TO_DURATION = 'secondsToDuration',
}

export { DATA_TABLE_COMPONENTS, FORMAT_COMPONENTS };
